<template>
  <div class="room-control">
    <div
      class="room-menu active"
      @click="$emit('onClickMic')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.mic')"
    >
      <v-fa :icon="enabledMic ? 'microphone' : 'microphone-slash'" size="lg" />
    </div>
    <div
      class="room-menu active"
      @click="$emit('onClickVideo')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.video')"
    >
      <v-fa :icon="enabledVideo ? 'video' : 'video-slash'" size="lg" />
    </div>
    <div
      v-if="isSupportedDisplayMedia && (projector.isStreamOwner || !projector.stream)"
      :class="['room-menu', { 'active': projector.isStreamOwner }]"
      @click="$emit('onClickProjector')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.projector')"
    >
      <v-fa icon="desktop" size="lg" />
    </div>
    <div
      :class="['room-menu', { 'active': enabledWhiteboard, 'blink': !enabledWhiteboard && !!projector.stream }]"
      @click="$emit('onClickWhiteboard')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.whiteboard')"
    >
      <v-fa icon="chalkboard" size="lg" />
    </div>
    <div
      :class="['room-menu', { 'active': enabledMinutes }]"
      @click="$emit('onClickMinutes')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.minutes')"
    >
      <v-fa icon="edit" size="lg" />
    </div>
    <div class="room-menu active"
      @click="$emit('onClickRoomLock')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.roomLock')"
    >
      <v-fa :icon="enabledRoomLock ? 'lock' : 'unlock'" size="lg" />
    </div>
    <div
      class="room-menu active"
      @click="$emit('onClickExitRoom')"
      v-b-tooltip.hover
      :title="isMobile ? null : $t('pages.room.tooltip.exitRoom')"
    >
      <v-fa icon="sign-out-alt" size="lg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomControl',
  props: {
    isMobile: Boolean,
    isSupportedDisplayMedia: Boolean,
    enabledMic: Boolean,
    enabledVideo: Boolean,
    enabledWhiteboard: Boolean,
    enabledMinutes: Boolean,
    enabledRoomLock: Boolean,
    projector: Object
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.room-control {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border-radius: 20px;
  padding: 0 20px;
  background-color: white;

  .room-menu {
    cursor: pointer;
    padding: 10px 15px;
    @include mq(md) {
      padding: 10px 20px;
    }
    color: $tertiary-translucent-color;

    &.active {
      color: $primary-translucent-color;
    }
  }
}
</style>
